// Generated by CoffeeScript 1.9.3
var _LineAppendor;

module.exports = _LineAppendor = (function() {
  function _LineAppendor(_config) {
    this._config = _config;
    this._lineNo = 0;
  }

  _LineAppendor.prototype.render = function(inherited, options) {
    this._lineNo++;
    return '<none>' + this._render(inherited, options) + '</none>';
  };

  return _LineAppendor;

})();



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/layout/block/lineAppendor/_LineAppendor.js
// module id = 403
// module chunks = 0